export const ENV = () => {
  // if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  //   return 'LOCAL';
  // else if (window.location.hostname === 'dev.communityenergylabs.com') 
    return 'DEV';
};

export const API_BASE = "https://api.communityenergylabs.org"
export const LOCAL_BASE = "http://localhost"

export const CREATE_SERVICE_BASE = (route) =>
{
  var base
  if (ENV() === 'LOCAL') { base = LOCAL_BASE }
  else { base = API_BASE }

  return base + "/" + route;
}

export const DEVICE_SERVICE_BASE = () => { return CREATE_SERVICE_BASE("device"); }
export const BUILDING_METADATA_SERVICE_BASE = () => { return CREATE_SERVICE_BASE("metadata"); }
export const HISTORIAN_SERVICE_BASE = () => { return CREATE_SERVICE_BASE("historian"); }
export const CONTROL_SERVICE_BASE = () => { return CREATE_SERVICE_BASE("control"); }
export const EXTERNAL_SERVICE_BASE = () => { return CREATE_SERVICE_BASE("external"); }

export const SUPABASE_URL = 'https://sxgeyxyfabxcjhgylxii.supabase.co';
export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTY0MjA2MDMzMSwiZXhwIjoxOTU3NjM2MzMxfQ.NiSb-LZ7Vy__GMhIDc_lEsWU-ASEPnC3EhBqTJ4Wkbc';
